// extracted by mini-css-extract-plugin
module.exports = {"root":"X_bk","error":"X_7"};